import React from 'react';

/**
 * resmaker.ai Logo - Stylized "R" on document
 * Matches the favicon design
 */
function Logo({ size = 24, className = '' }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      width={size}
      height={size}
      className={className}
    >
      <defs>
        <linearGradient id="logoGrad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#7C3AED"/>
          <stop offset="100%" stopColor="#06B6D4"/>
        </linearGradient>
      </defs>
      {/* Paper/document background */}
      <rect x="4" y="2" width="24" height="28" rx="3" fill="url(#logoGrad)"/>
      {/* Folded corner */}
      <path d="M22 2L28 8H24C22.9 8 22 7.1 22 6V2Z" fill="white" fillOpacity="0.2"/>
      {/* Modern stylized R */}
      <path d="M9 7H17.5C20.5 7 23 9.5 23 12.5C23 14.8 21.5 16.7 19.4 17.4L23.5 25H19L15.5 18H13V25H9V7Z" fill="white"/>
      {/* R inner bowl cutout */}
      <path d="M13 10.5V14.5H17C18.4 14.5 19.5 13.4 19.5 12C19.5 10.6 18.4 10.5 17 10.5H13Z" fill="url(#logoGrad)"/>
    </svg>
  );
}

export default Logo;
